import React from 'react'
import styles from './ValueLabel.module.scss'
import { ValueLabelProps } from './types'

const ValueLabelComponent = (props: ValueLabelProps) => {
  const { label, value } = props

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        {label}
      </div>

      <div className={styles.shape}>
        {value}
      </div>
    </div>
  )
}

const ValueLabel = ValueLabelComponent
export { ValueLabel }
